// https://inclusive-components.design/collapsible-sections/
export default ( isFaqPage ) => {
	(function () {
		var headings
		if( isFaqPage ) {
			headings = document.querySelectorAll('.accordion h2');
		} else {
			headings = document.querySelectorAll('.accordion > h2');
		}

		if (headings) {
			Array.prototype.forEach.call(headings, h => {
				let btn = h.querySelector('button');
				let target = h.nextElementSibling;
				// console.log('target', target);

				btn.onclick = () => {
					let expanded = btn.getAttribute('aria-expanded') === 'true';

					btn.setAttribute('aria-expanded', !expanded);
					target.hidden = expanded;
				}
			});
		}
	})()
}